import HTTP from "../../../services/HTTP.js";
// fetch notifiations
export const getNotifications = async (paramsOptions) => {
  const { page, limit } = paramsOptions || {};
  const res = await HTTP.get("/notifications", {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// fetch notifications by user id
export const getNotificationByUserId = async (paramsOptions) => {
  const { page, limit } = paramsOptions || {};
  const res = await HTTP.get(`notifications/byUser`, {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// fetch unread notification
export const getUnreadNotification = async () => {
  const res = await HTTP.get(`notifications/unread`);
  return res.data;
};

// fetch read notification
export const getReadNotification = async () => {
  const res = await HTTP.put(`notifications/read`);
  return res.data;
};

// add notification
export const addNotification = async (data) => {
  const res = await HTTP.post("notifications/add", data);
  return res.data;
};

// delete notification
export const deleteNotifiation = async (id) => {
  const res = await HTTP.delete(`notifications/delete/${id}`);
  return res.data;
};
